// extracted by mini-css-extract-plugin
module.exports = {"box":"AvailableCoupon-module__box___ZnWcx","couponCurrency":"AvailableCoupon-module__couponCurrency___1uMpx","selected":"AvailableCoupon-module__selected___1kvSp"};